import { useSelector } from "react-redux";
import { getMessagePreviewById } from "utils/message";
import errorImg from "assets/icons/Icon-error-red.svg";
import { handleScrollIntoView } from "utils/view";

const getLocale = ({ settingsData }) => settingsData.locale;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

const ImageMessage = ({ id, error, url, replyId }) => {
  const locale = useSelector(getLocale);
  const selectedConversation = useSelector(getSelectedConversation);

  const handleShowRepliedMessage = () => {
    handleScrollIntoView(replyId);
  };

  return (
    <div
      data-id={id}
      className="conv__body__body__inner__msgright__inner__bubble"
    >
      <div className="conv__body__body__inner__msgright__inner__bubble__image ">
        {replyId && (
          <div
            dir="auto"
            className="conv__body__body__inner__msgright__inner__bubble__replied_msg"
            onClick={handleShowRepliedMessage}
          >
            <span>
              {getMessagePreviewById(replyId, selectedConversation, locale)}
            </span>
          </div>
        )}
        <a href={url} target="_blank" rel="noreferrer">
          <img
            src={url}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = errorImg;
            }}
            alt=""
          />
        </a>
        <div
          style={{ display: !error ? "none" : "" }}
          className="conv__body__body__inner__msgright__inner__bubble__image__info flex flex-ai-c flex-jc-c"
        >
          {error && (
            <div className="conv__body__body__inner__msgright__inner__bubble__image__info__delivery error"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageMessage;
